
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["sgv",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"18","height":"18"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16 16.2H2V6.3h14M13 0v1.8H5V0H3v1.8H2a1.9 1.9 0 00-2 1.8v12.6A1.908 1.908 0 002 18h14a1.908 1.908 0 002-1.8V3.6a1.908 1.908 0 00-2-1.8h-1V0","fill":"#fff"}})])
          )
        }
      }
    